var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasImovel
    ? _c(
        "div",
        [
          _c("app-divider", { attrs: { label: "Dados gerais" } }),
          _vm.hasEndereco
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouBairro
                              ? "text"
                              : "",
                            attrs: {
                              id: "BAIRRO",
                              label: "Bairro:",
                              content: _vm.exibirCampoComum(
                                _vm.cadastroOriginal.imovel.endereco,
                                "bairro"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouLoteamantoVila
                              ? "text"
                              : "",
                            attrs: {
                              id: "ENDERECO",
                              label: "Endereço:",
                              content: _vm.exibirCampoComum(
                                _vm.cadastroOriginal.imovel.endereco,
                                "loteamentoVila"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouNumero
                              ? "text"
                              : "",
                            attrs: {
                              id: "NUMERO",
                              label: "Número:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "numero"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouComplemento
                              ? "text"
                              : "",
                            attrs: {
                              id: "COMPLEMENTO",
                              label: "Complemento:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "complemento"
                                ) || "-",
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararImovelReurb.mudouArea
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "AREA_IMOVEL",
                                  label: "Área do imóvel (m²):",
                                  content:
                                    _vm.exibirCampoComum(
                                      _vm.cadastroOriginal.imovel,
                                      "area"
                                    ) || "-",
                                  marginBottom: true
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouLote
                              ? "text"
                              : "",
                            attrs: {
                              id: "LOTE",
                              label: "Lote:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "lote"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouQuadra
                              ? "text"
                              : "",
                            attrs: {
                              id: "QUADRA",
                              label: "Quadra:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "quadra"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouAreaConstruida
                              ? "text"
                              : "",
                            attrs: {
                              id: "PERIMETRO_LOTE",
                              label: "Perímetro do lote (m²):",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel,
                                  "areaConstruida"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararImovelReurb.mudouArea
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "AREA_LOTE",
                                  label: "Área do lote (m²):",
                                  content:
                                    _vm.exibirCampoComum(
                                      _vm.cadastroOriginal.imovel,
                                      "area"
                                    ) || "-",
                                  marginBottom: true
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.cadastroOriginal.imovel.bemUnico
                              ? "text"
                              : "-",
                            attrs: {
                              id: "BEM_UNICO",
                              label: "É bem único:",
                              content: _vm.cadastroOriginal.imovel.bemUnico
                                ? "Sim"
                                : "Não"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.cadastroOriginal.imovel.possuiMatricula
                              ? "text"
                              : "-",
                            attrs: {
                              id: "MATRICULA",
                              label: "Possui matrícula:",
                              content: _vm.getPossuiMatricula()
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("app-divider", {
            attrs: { label: "Características gerais do imóvel" }
          }),
          _c(
            "div",
            { staticClass: "margin-top-10" },
            [
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouOcupacao
                          ? "text"
                          : "",
                        attrs: {
                          id: "OCUPACAO",
                          label: "Ocupação:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.ocupacao,
                            "ocupacao"
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouEstadoImovel
                          ? "text"
                          : "",
                        attrs: {
                          id: "TIPO",
                          label: "Tipo:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.estadoImovel,
                            "estadoImovel"
                          ),
                          marginBottom: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouDominilidade
                          ? "text"
                          : "",
                        attrs: {
                          id: "DOMINIALIDADE",
                          label: "Dominialidade:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.dominialidade,
                            "dominilidade"
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _vm.cadastroOriginal.imovel.regimeUsos &&
                  _vm.cadastroOriginal.imovel.regimeUsos.length > 0
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouRegimeUso
                              ? "text"
                              : "",
                            attrs: {
                              id: "REGIME_USOS",
                              label: "Regime de uso:",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.regimeUsos,
                                "regimeUsos"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.cadastroOriginal.imovel.regimeUso
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouRegimeUso
                              ? "text"
                              : "",
                            attrs: {
                              id: "REGIME_USO",
                              label: "Regime de uso:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.regimeUso,
                                "regimeUso"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm.hasTerreno
            ? _c("app-divider", {
                attrs: { label: "Características do terreno" }
              })
            : _vm._e(),
          _vm.hasTerreno
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouLocalizacao
                              ? "text"
                              : "",
                            attrs: {
                              id: "LOCALIZACAO",
                              label: "Localização:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno.localizacao,
                                "localizacao"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm.cadastroOriginal.imovel.terreno.delimitacao
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouDelimitacao
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "DELIMITACAO",
                                  label: "Delimitação:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.terreno
                                      .delimitacao,
                                    "delimitacao"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.cadastroOriginal.imovel.terreno.delimitacoes
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display-multiple", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouDelimitacaos
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "DELIMITACOES",
                                  label: "Delimitação:",
                                  content: _vm.exibirValores(
                                    _vm.cadastroOriginal.imovel.terreno
                                      .delimitacoes,
                                    "delimitacoes"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouCalcadaExterna
                              ? "text"
                              : "",
                            attrs: {
                              id: "CALCADA_EXTERNA",
                              label: "Calçada externa:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno
                                  .calcadaExterna,
                                "calcadaExterna"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouQuintalAreaLivre
                              ? "text"
                              : "",
                            attrs: {
                              id: "QUINTAL_AREA_LIVRE",
                              label: "Quintal área livre:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno
                                  .quintalAreaLivre,
                                "quintalAreaLivre"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasUnidade
            ? _c("app-divider", { attrs: { label: "Uso da unidade" } })
            : _vm._e(),
          _vm.hasUnidade
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouUsoSolos
                              ? "text"
                              : "",
                            attrs: {
                              id: "USO_SOLO",
                              label: "Uso do solo:",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.unidade.usoSolos,
                                "usoSolos"
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouOutroUsoSolo
                              ? "text"
                              : "",
                            attrs: {
                              id: "OUTRO_USO_SOLO",
                              label: "Especificação:",
                              content:
                                _vm.cadastroOriginal.imovel.unidade.outroUsoSolo
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasConstrucao
            ? _c("app-divider", {
                attrs: { label: "Características externas da construção" }
              })
            : _vm._e(),
          _vm.hasConstrucao
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouCoberturas
                              ? "text"
                              : "",
                            attrs: {
                              id: "COBERTURA",
                              label: "Cobertura:",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.construcao
                                  .coberturas,
                                "coberturas"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouEstruturas
                              ? "text"
                              : "",
                            attrs: {
                              id: "ESTRUTURA_PAREDE",
                              label: "Estrutura (parede):",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.construcao
                                  .estruturas,
                                "estruturas"
                              ),
                              marginBottom: true
                            }
                          }),
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouOutroEstrutura
                              ? "text"
                              : "",
                            attrs: {
                              id: "OUTRO_ESTRUTURA_PAREDE",
                              label: "Especificação:",
                              content:
                                _vm.cadastroOriginal.imovel.construcao
                                  .outroEstrutura,
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasConstrucao
            ? _c("app-divider", {
                attrs: { label: "Características internas da construção" }
              })
            : _vm._e(),
          _vm.hasConstrucao
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouFornecimentoEnergia
                              ? "text"
                              : "",
                            attrs: {
                              id: "FORNECIMENTO_ENERGIA",
                              label: "Fornecimento de energia:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.construcao
                                  .fornecimentoEnergia,
                                "fornecimentoEnergia"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouNumCompartimentos
                              ? "text"
                              : "",
                            attrs: {
                              id: "NUMERO_COMPARTIMENTOS",
                              label: "Número de compartimentos:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.construcao,
                                  "numCompartimentos"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouNumQuartos
                              ? "text"
                              : "",
                            attrs: {
                              id: "NUMERO_QUARTOS",
                              label: "Número de quartos:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.construcao,
                                  "numQuartos"
                                ) || "-",
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasConstrucao
            ? _c("app-divider", {
                attrs: { label: "Saneamento básico e meio ambiente" }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "margin-top-10" },
            [
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouSistemaSanitario
                          ? "text"
                          : "",
                        attrs: {
                          id: "SISTEMA_SANITARIOS",
                          label: "Sistema do sanitário:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.sistemaSanitario,
                            "sistemaSanitario"
                          ),
                          marginBottom: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display-multiple", {
                        class: _vm.compararImovelReurb.mudouDestinacaoLixos
                          ? "text"
                          : "",
                        attrs: {
                          id: "DESTINACAO_LIXO",
                          label: "Destinação do lixo:",
                          content: _vm.exibirValores(
                            _vm.cadastroOriginal.imovel.destinacaoLixos,
                            "destinacaoLixos"
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display-multiple", {
                        class: _vm.compararImovelReurb.mudouAbastecimentoAgua
                          ? "text"
                          : "",
                        attrs: {
                          id: "TIPO_ABASTECIMENTO_AGUA",
                          label: "Tipo de abastecimento de água:",
                          content: _vm.exibirValores(
                            _vm.cadastroOriginal.imovel.abastecimentosAgua,
                            "abastecimentosAgua"
                          ),
                          marginBottom: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.hasDadosDeclaracaoPosseImovel
            ? _c("app-divider", {
                attrs: { label: "Declaração de posse do imóvel" }
              })
            : _vm._e(),
          _vm.hasDadosDeclaracaoPosseImovel
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-display", {
                            class: "text",
                            attrs: {
                              id: "DECLARACAO_POSSE_IMOVEL",
                              label:
                                "Você possui declaração de posse do imóvel?",
                              content: _vm.hasDeclaracaoPosse ? "Sim" : "Não"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.hasDeclaracaoPosse &&
                      !_vm.hasDocumentoDeclaracaoPosse
                        ? _c(
                            "div",
                            [
                              _c("app-display", {
                                class: "text",
                                staticStyle: {
                                  "text-align": "center",
                                  "font-weight": "bold"
                                },
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_TITULO
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_1
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_2
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_3
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: { content: this.tempoPosse }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasDadosDeclaracaoResidencia
            ? _c("app-divider", {
                attrs: { label: "Declaração de residência" }
              })
            : _vm._e(),
          _vm.hasDadosDeclaracaoResidencia
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-display", {
                            class: "text",
                            attrs: {
                              id: "DECLARACAO_RESIDENCIA_IMOVEL",
                              label: "Você possui declaração de residência?",
                              content: _vm.cadastroOriginal.imovel
                                .possuiDeclaracaoResidencia
                                ? "Sim"
                                : "Não"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.cadastroOriginal.imovel.possuiDeclaracaoResidencia &&
                      !_vm.hasDocumentoDeclaracaoResidencia
                        ? _c(
                            "div",
                            [
                              _c("app-display", {
                                class: "text",
                                staticStyle: {
                                  "text-align": "center",
                                  "font-weight": "bold"
                                },
                                attrs: {
                                  content: this.messages
                                    .TITULO_DECLARACAO_RESIDENCIA
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: { content: this.endereco }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_RESIDENCIA
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                staticStyle: { "margin-left": "60px" },
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_RESIDENCIA_LEI
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_RESIDENCIA_ASSINATURA
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("app-divider", { attrs: { label: "Informações complementares" } }),
          _c(
            "div",
            { staticClass: "margin-top-10" },
            [
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouObservacoesGerais
                          ? "text"
                          : "",
                        attrs: {
                          id: "INFORMACOES_NECESSARIAS",
                          label: "Informações necessárias (se houver):",
                          content:
                            _vm.cadastroOriginal.imovel.observacoesGerais || "-"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d67aff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d67aff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/ma/InformacoesImovelReurb.vue
// module id = null
// module chunks = 